import React from 'react';
import styled from 'styled-components';
import { FormField as FormFieldType } from '../types/FormTypes';
import TextInput from './inputs/TextInput';
import NumberInput from './inputs/NumberInput';
import DateInput from './inputs/DateInput';
import TextArea from './inputs/TextArea';
import EmailInput from './inputs/EmailInput';
import FileUpload from './inputs/FileUpload';

const FieldWrapper = styled.div`
  margin-bottom: 24px;
`;

const FieldInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FieldName = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
  display: block;
`;

const RequiredAsterisk = styled.span`
  color: #e74c3c;
  margin-left: 4px;
`;

const FieldDescription = styled.p`
  font-size: 12px;
  color: #666666;
  margin-bottom: 8px;
`;

const ControlWrapper = styled.div`
  position: relative;
`;

interface FormFieldProps {
  field: FormFieldType;
  value: string | number | File | null;
  onChange: (value: string | number | File | null) => void;
}

const FormField: React.FC<FormFieldProps> = ({ field, value, onChange }) => {
  const renderInput = () => {
    const fieldName = `field_${field.field.id}`;
    
    switch (field.field.type) {
      case 'text':
        return (
          <TextInput
            value={value as string}
            onChange={onChange}
            placeholder={field.field.text_default}
            required={true}
            name={fieldName}
          />
        );
      case 'number':
        return (
          <NumberInput
            value={value as number}
            onChange={onChange}
            required={true}
            name={fieldName}
          />
        );
      case 'date':
        return (
          <DateInput
            value={value as string}
            onChange={onChange}
            required={true}
            name={fieldName}
          />
        );
      case 'long_text':
        return (
          <TextArea
            value={value as string}
            onChange={onChange}
            placeholder={field.field.text_default}
            required={true}
            name={fieldName}
          />
        );
      case 'email':
        return (
          <EmailInput
            value={value as string}
            onChange={onChange}
            required={true}
            name={fieldName}
          />
        );
      case 'file':
        return (
          <FileUpload
            value={value as File}
            onChange={onChange}
            required={true}
            name={fieldName}
            accept="image/*"
            enableCrop={true}
          />
        );
      default:
        return <div>Неизвестный тип поля: {field.field.type}</div>;
    }
  };

  return (
    <FieldWrapper>
      <FieldInner>
        <FieldName>
          {field.name}
          <RequiredAsterisk>*</RequiredAsterisk>
        </FieldName>
        {field.description && (
          <FieldDescription>{field.description}</FieldDescription>
        )}
        <ControlWrapper>
          {renderInput()}
        </ControlWrapper>
      </FieldInner>
    </FieldWrapper>
  );
};

export default FormField;